export enum ContainerEnum {
    Container = "container",
    Glass = "glass",
    Paper = "paper",
    Plastic = "plastic",
    Metal = "metal",
    Underground = "underground"
}